import Vue from 'vue'

Date.prototype.format = function (fmt) {
	            var o = {
	                "M+": this.getMonth() + 1, //月份
	                "d+": this.getDate(), //日
	                "h+": this.getHours(), //小时
	                "m+": this.getMinutes(), //分
	                "s+": this.getSeconds(), //秒
	                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
	                "S": this.getMilliseconds() //毫秒
	            };
	            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	            for (var k in o)
	                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	            return fmt;
	        }

let today = function () {
  //今天
  var day = new Date();
  return { Begin: day.format("yyyy-MM-dd"), End: day.format("yyyy-MM-dd")};
}

let thisWeek = function () {
  //本周星期日是几号
  var day = new Date();
  var num = day.getDay();
  day.setDate(day.getDate() + 7 - num); //如果把周日看作第一天，那就改成0，如果把星期日看作本周最后一天，则改为7
  var end = day;
  day = new Date();
  day.setDate(day.getDate() + 1 - num);
  var begin = day;
  return { Begin: begin.format("yyyy-MM-dd"), End: end.format("yyyy-MM-dd") };
}			

let thisMonth = function () {
  //本月第一天
  var day = new Date();
  day.setDate(1);
  var begin = day;
  day = new Date();
  day.setDate(1);
  day.setMonth(day.getMonth() + 1);//这时候day已经变成下个月第一天
  day.setDate(day.getDate() - 1);//下个月的第一天的前一天就是本月最后一天
  var end = day;
  return { Begin: begin.format("yyyy-MM-dd"), End: end.format("yyyy-MM-dd") };
}

let thisYear = function () {
  var year = new Date().getFullYear();
  return { Begin: year + "-01-01", End: year + "-12-31" };
}
 
export default {
  today,
  thisWeek,
  thisMonth,
  thisYear
}



//////////////////
// WEBPACK FOOTER
// ./static/js/dateUtil.js
// module id = null
// module chunks = 